export function RatingAndElo({
  rating,
  elo,
}: {
  rating: number;
  elo: number | null;
}) {
  const flooredElo = elo ? Math.floor(elo) : null;
  const bgColor = {
    1: "bg-red-500",
    2: "bg-red-800",
    3: "bg-purple-500",
    4: "bg-purple-800",
    5: "bg-blue-800",
    6: "bg-blue-500",
  };

  return (
    <div
      className={`flex items-center gap-2 rounded-full px-3 py-2 text-white ${bgColor[rating] || "bg-gray-500"}`}
    >
      <span
        className={`font-spacemono text-[0.7rem] font-extrabold not-italic text-white`}
      >
        {rating}
      </span>
      {elo && <span className="text-[0.45rem]">{`${flooredElo}`}</span>}
    </div>
  );
}
